

export default {
    name: "ReportSubscriptionBanner",

    props: {
        isActivated: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['open-modal'],

    data() {
        return {
            isOpened: false,
        }
    },

    computed: {
        editIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/edit-dark.svg') :
                require('@/assets/icons/edit-light.svg');
        },
    },

    methods: {
        openModal() {
            this.$emit('open-modal', true);
        },
    },
}
